document.querySelectorAll('[data-cfs-dropzone]').forEach(function (zone) {
  var input = zone.querySelector('[data-cfs-file]');
  var text = zone.querySelector('[data-cfs-dropzone-text]');
  if (!input || !text) return;

  var defaultText = text.textContent;

  function showFile(file) {
    if (file) {
      text.textContent = file.name;
    } else {
      text.textContent = defaultText;
    }
  }

  input.addEventListener('change', function () {
    showFile(input.files && input.files[0]);
  });

  ['dragenter', 'dragover'].forEach(function (evt) {
    zone.addEventListener(evt, function (e) {
      e.preventDefault();
      zone.classList.add('is-dragover');
    });
  });

  ['dragleave', 'dragend', 'drop'].forEach(function (evt) {
    zone.addEventListener(evt, function (e) {
      e.preventDefault();
      zone.classList.remove('is-dragover');
    });
  });

  zone.addEventListener('drop', function (e) {
    var file = e.dataTransfer && e.dataTransfer.files && e.dataTransfer.files[0];
    if (file) {
      try {
        input.files = e.dataTransfer.files;
      } catch (err) {
        /* older browsers may not allow assigning dropped files */
      }
      showFile(file);
    }
  });
});
